import { render, staticRenderFns } from "./BahanPacking.vue?vue&type=template&id=1394fe64&"
import script from "./BahanPacking.vue?vue&type=script&lang=js&"
export * from "./BahanPacking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports